var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatPasteGo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3034_988",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3034_988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21.525L16.325 19.85L17.75 18.425H13.825V16.075H17.75L16.325 14.65L18 12.975L22.275 17.25L18 21.525ZM1.82495 22.025V3.57495H19.425V11.175C19.1971 11.1028 18.961 11.0555 18.7167 11.0332C18.4722 11.011 18.2312 11 17.9937 11C17.8395 11 17.6854 11.0097 17.5312 11.0292C17.377 11.0485 17.225 11.0805 17.075 11.125V5.92495H4.17495V16.075H12.125C12.0805 16.225 12.0485 16.377 12.0292 16.5312C12.0097 16.6854 12 16.8395 12 16.9937C12 17.2312 12.011 17.4722 12.0332 17.7167C12.0555 17.961 12.1028 18.1971 12.175 18.425H5.42495L1.82495 22.025ZM6.04995 9.84995H15.225V7.79995H6.04995V9.84995ZM6.04995 13.95H12.225V11.9H6.04995V13.95Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPasteGo);
export default __webpack_public_path__ + "static/media/chat_paste_go.6a5232e34f866a3e852564223f8cea38.svg";
export { ForwardRef as ReactComponent };